// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3265-55566
// Component: SveaPartner (mapped to PartnerContact)
// Variants:
//   type="contact" (default) — booking summary row: logo | name + email/phone | call button
//   type="option"            — selection list row:  logo | name + subtitle | price + radio

import classnames from 'classnames'
import Spinner from '~/components/ui/Spinner'

function PartnerLogo({ providerId }) {
  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'
  const src = providerId === 'TSAB'
    ? `/app/themes/${theme}/static/img/logo.png`
    : `/app/themes/${theme}/static/img/logo-allians.png`
  return <img src={src} alt="" className="size-8 object-contain" />
}

function PhoneIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6.2528 5.50015C6.84173 5.50022 7.48958 6.14708 7.75475 6.41226C8.01982 6.67733 9.19825 8.0917 9.37487 8.85757C9.50276 9.41322 8.85517 10.3101 8.40026 10.9406C8.22821 11.179 8.08411 11.3796 8.0194 11.5089C7.78765 11.9723 8.21478 13.0202 9.60729 14.3927C10.9992 15.7646 12.0265 16.2118 12.4901 15.9806C12.6195 15.9159 12.82 15.7708 13.0585 15.5988C13.689 15.1438 14.5868 14.497 15.1424 14.6251C15.9083 14.8021 17.3215 15.979 17.5868 16.2443C17.8518 16.5093 18.5 17.1581 18.4999 17.7472C18.4992 18.3302 17.2885 19.4317 17.2626 19.4552C17.2626 19.4552 15.5535 20.9283 13.0204 20.0451C10.8303 19.2814 9.368 18.3961 7.48522 16.5138C5.60711 14.6361 4.72036 13.1775 3.95397 10.9796C3.0746 8.45769 4.53084 6.75257 4.54381 6.73745C4.54381 6.73745 5.66364 5.50025 6.2528 5.50015ZM19.1923 4.00894C19.4711 4.00961 19.6111 4.01018 19.7176 4.0646C19.8113 4.11249 19.8876 4.18871 19.9354 4.28238C19.9897 4.3889 19.9904 4.52824 19.9911 4.80679L19.9999 9.57046C20.0004 9.80295 19.9998 9.91936 19.9745 10.0148C19.9057 10.2736 19.7046 10.476 19.4462 10.546C19.3508 10.5718 19.2343 10.5728 19.0018 10.5734C18.7693 10.574 18.6529 10.5733 18.5575 10.548C18.2987 10.4792 18.0963 10.2781 18.0262 10.0197C18.0005 9.92437 18.0004 9.80784 17.9999 9.57534V8.37905L18.0233 7.3898L14.201 11.213C14.0369 11.3772 13.9545 11.4596 13.869 11.5089C13.637 11.6428 13.351 11.6428 13.119 11.5089C13.0335 11.4596 12.9513 11.3773 12.787 11.213C12.6228 11.0489 12.5405 10.9664 12.4911 10.881C12.3572 10.6491 12.3573 10.363 12.4911 10.131C12.5404 10.0455 12.6226 9.9624 12.787 9.798L16.6092 5.97573L15.62 6.00015H14.4247C14.1923 5.99959 14.0756 5.99954 13.9803 5.97378C13.7218 5.90384 13.5199 5.70133 13.451 5.44253C13.4257 5.34714 13.4261 5.23048 13.4266 4.9982C13.4272 4.76579 13.4272 4.64915 13.453 4.55386C13.523 4.29521 13.7262 4.09329 13.9852 4.02456C14.0806 3.99932 14.1973 3.99959 14.4296 4.00015L19.1923 4.00894Z" fill="#17181A"/>
    </svg>
  )
}

// Matches RadioIcon in CarRadioField (Figma node 52:1061 / 52:1063)
function RadioIcon({ selected }) {
  if (selected) {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" className="shrink-0">
        <rect x="0.25" y="0.25" width="21.5" height="21.5" rx="10.75" fill="#FFCC00" />
        <rect x="0.25" y="0.25" width="21.5" height="21.5" rx="10.75" stroke="#BA8200" strokeWidth="0.5" />
        <path fillRule="evenodd" clipRule="evenodd" d="M16.1404 6.74141C16.3176 6.88535 16.4061 6.95732 16.4635 7.03588C16.6206 7.25109 16.6517 7.53347 16.5452 7.77772C16.5064 7.86689 16.4356 7.95642 16.294 8.13548L10.6357 15.2931C10.4676 15.5057 10.3836 15.6121 10.2776 15.6621C10.1843 15.7062 10.0797 15.7203 9.97813 15.7026C9.86267 15.6825 9.75339 15.6023 9.53484 15.4419L5.92882 12.7955C5.73218 12.6512 5.63385 12.579 5.57038 12.4981C5.40396 12.2859 5.36426 12.0007 5.46639 11.7512C5.50535 11.656 5.58023 11.5597 5.72998 11.3672C5.87077 11.1862 5.94116 11.0957 6.01956 11.0362C6.2248 10.8806 6.49554 10.8411 6.73664 10.9317C6.82875 10.9664 6.92204 11.033 7.10862 11.1664L9.8395 13.1178L14.7258 6.89943C14.8706 6.71509 14.943 6.62293 15.0224 6.56357C15.2401 6.40085 15.5287 6.36861 15.7769 6.47929C15.8675 6.51967 15.9585 6.59358 16.1404 6.74141Z" fill="#17181A" />
      </svg>
    )
  }
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true" className="shrink-0">
      <circle cx="11" cy="11" r="10.5" stroke="#8c8c8c" strokeWidth="1" />
    </svg>
  )
}

export default function PartnerContact({ type = 'contact', providerId, name, phone, displayPhone, email, subtitle, price, originalPrice, priceLoading, selected, onClick, disabled }) {
  const isOption = type === 'option'
  const telHref = phone ? `tel:${phone}` : null

  if (isOption) {
    return (
      <div
        onClick={onClick}
        className={classnames('flex items-center gap-3 py-3 w-full', onClick && 'cursor-pointer', disabled && 'opacity-[0.38]')}
      >
        <div className="shrink-0 size-11 flex items-center justify-center">
          <PartnerLogo providerId={providerId} />
        </div>

        <div className="flex-1 flex flex-col items-start min-w-0">
          <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{name}</span>
          {subtitle && (
            <span className="text-[15px] leading-5 text-on-surface-variant">{subtitle}</span>
          )}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          {priceLoading ? (
            <Spinner size={16} className="shrink-0" />
          ) : price ? (
            <div className="flex flex-col items-end">
              <span className="text-[17px] font-semibold uppercase tracking-[0.68px] leading-[22px] text-on-surface whitespace-nowrap">
                {price}
              </span>
              {originalPrice && (
                <s className="text-[15px] leading-5 text-on-surface-variant">{originalPrice}</s>
              )}
            </div>
          ) : null}
          <label className="cursor-pointer" onClick={e => e.stopPropagation()}>
            <RadioIcon selected={selected} />
            <input
              type="radio"
              className="sr-only"
              name="selectedProviderId"
              checked={selected}
              onChange={onClick}
            />
          </label>
        </div>
      </div>
    )
  }

  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      <div className="shrink-0 size-11 flex items-center justify-center">
        <PartnerLogo providerId={providerId} />
      </div>

      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{name}</span>
        {displayPhone && (
          telHref
            ? <a href={telHref} className="text-[15px] leading-5 text-on-surface-variant">{displayPhone}</a>
            : <span className="text-[15px] leading-5 text-on-surface-variant">{displayPhone}</span>
        )}
        {email && (
          <a href={`mailto:${email}`} className="text-[15px] leading-5 text-on-surface-variant">{email}</a>
        )}
      </div>

      {telHref && !disabled && (
        <a href={telHref} className="shrink-0 p-2 -mr-2" aria-label={`Ring ${name}`}>
          <PhoneIcon />
        </a>
      )}
    </div>
  )
}
